// extracted by mini-css-extract-plugin
export var divider = "_px-0";
export var systemMessage = "_px-1";